import {Registered} from './EducationShell';
import styles from './ZepboundDisclaimer.module.css';

const PRESCRIBING_INFO_URL = 'https://pi.lilly.com/us/zepbound-uspi.pdf';
const MEDICATION_GUIDE_URL = 'https://pi.lilly.com/us/zepbound-us-mg.pdf';

/**
 * Shared legal / safety disclaimer block appended to the bottom of every
 * branded Zepbound education screen.
 */
export const ZepboundDisclaimer = () => (
  <div className={styles.container}>
    <p className={styles.body}>
      Zepbound
      <Registered size={9} /> is a registered trademark of Eli Lilly and Company. RISE is not affiliated with or
      endorsed by Eli Lilly.
    </p>
    <p className={`${styles.body} ${styles.spacedBlock}`}>
      Important Safety Information: Zepbound
      <Registered size={9} /> (tirzepatide) may cause serious side effects including thyroid C-cell tumors, inflammation
      of the pancreas, gallbladder problems, severe stomach problems, and changes in vision. Tell your healthcare
      provider about all medical conditions before use. See{' '}
      <a className={styles.link} href={PRESCRIBING_INFO_URL} target="_blank" rel="noreferrer noopener">
        full Prescribing Information
      </a>{' '}
      and{' '}
      <a className={styles.link} href={MEDICATION_GUIDE_URL} target="_blank" rel="noreferrer noopener">
        Medication Guide
      </a>
      .
    </p>
  </div>
);
